import { Directive, EventEmitter, Output, ElementRef, OnDestroy, AfterContentInit, HostListener } from '@angular/core';
import { fromEvent, Observer, Observable, Subscription, merge } from 'rxjs';
import { throttleTime } from 'rxjs/operators';

@Directive({
    selector: '[passiveTouchStart]', // OBS: Selected with (passiveTouchStart)
})
export class PassiveTouchstartDirective implements AfterContentInit, OnDestroy {
    @Output('passiveTouchStart') ev = new EventEmitter<Event>();

    private evSub: Subscription = null;
    constructor(private elRef: ElementRef) { }

    ngAfterContentInit() {
        // // Add non passive toouchstart event listener
        let touchStart = fromEvent(this.elRef.nativeElement, 'touchstart', { passive: true });
        let mouseDown = fromEvent(this.elRef.nativeElement, 'mousedown', { passive: true });
        // Use throttle time to prevent double events on touch devices (in case preventDefault is not called)
        this.evSub = merge(touchStart, mouseDown).pipe(throttleTime(250)).subscribe((ev: Event) => this.ev.emit(ev));
    }

    ngOnDestroy() {
        // Clean up - remove event listener on destroy
        if(this.evSub) this.evSub.unsubscribe();
    }
}

@Directive({
    selector: '[passiveTouchEnd]',
})
export class PassiveTouchendDirective implements AfterContentInit, OnDestroy {
    @Output('passiveTouchEnd') ev = new EventEmitter<Event>();

    private evSub: Subscription = null;
    constructor(private elRef: ElementRef) { }

    ngAfterContentInit() {
        // Add passive toouchstart event listener
        let touchEnd = fromEvent(this.elRef.nativeElement, 'touchend', { passive: true });
        let mouseUp = fromEvent(this.elRef.nativeElement, 'mouseup', { passive: true });
        // Use throttle time to prevent double events on touch devices (in case preventDefault is not called)
        this.evSub = merge(touchEnd, mouseUp).pipe(throttleTime(250)).subscribe((ev: Event) => this.ev.emit(ev));
    }

    ngOnDestroy() {
        // Clean up - remove event listener on destroy
        if(this.evSub) this.evSub.unsubscribe();
    }
}
